import React from "react";
import Typography from "material-ui/Typography";
import Table from "material-ui/Table";
import { TableBody } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableRow } from "material-ui/Table";

import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { degreeCelsiusToFahrenheit } from "../../../../../common/utils";
const OpticalInt = props => (
  <Table className={props.classes.table}>
    <TableBody>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("test_types_signaltek") + ":"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate(props.data.type)}
        </TableCell>
      </TableRow>
      <TableRow style={{ display: props.hideLinkStatus ? "none" : "table-row" }}>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("sub_test_link_status") + ":"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.data.optical.linkstatus}
        </TableCell>
      </TableRow>
      <TableRow style={{ display: props.hideLinkStatus ? "none" : "table-row" }}>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("sub_test_link_speed") + ":"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.data.optical.linkspeed}
        </TableCell>
      </TableRow>
      <TableRow style={{ display: props.hideLinkStatus ? "none" : "table-row" }}>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("result_duplex")}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.data.optical.linkduplex}
        </TableCell>
      </TableRow>
      <TableRow style={{ display: props.hideLinkStatus ? "none" : "table-row" }}>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("result_pr_status")}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.data.optical.status}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("result_module")}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.data.optical.moduletype}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("result_vendor") + ": "}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.data.optical.vendor}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("result_prt_num")}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.data.optical.partnumber}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("result_wavelength") + ": "}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.data.optical.wavelength}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("result_rx_pow") + ": "}
        </TableCell>
        <TableCell
          className={props.classes.tablecontent_first}
          style={{
            color: props.data.optical.rxpowercolour
              ? props.data.optical.rxpowercolour
              : "black"
          }}
        >
          {props.data.optical.rxpower && props.data.optical.rxpower < 99999
            ? props.data.optical.rxpower.toFixed(2)
            : "-"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("result_tx_pow")}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.data.optical.txpower && props.data.optical.txpower < 99999
            ? props.data.optical.txpower.toFixed(2)
            : "-"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("result_temp")}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.data.optical.temperature &&
          props.data.optical.temperature < 99999
            ? props.data.optical.temperature.toFixed(2) + "  /  " + degreeCelsiusToFahrenheit(props.data.optical.temperature)
            : "-"}
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
);
export default withStyles(styles)(OpticalInt);
